export default __webpack_public_path__ + "static/media/52.b09a3920.svg";